var _line, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaint1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 475,
    viewBox: "0 0 172 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 6,
    x2: 80,
    y2: 469,
    stroke: "#22B260",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 6C171.333 3.05448 168.946 0.666666 166 0.666667C163.054 0.666667 160.667 3.05448 160.667 6C160.667 8.94552 163.054 11.3333 166 11.3333C168.946 11.3333 171.333 8.94552 171.333 6ZM166 5L-8.74227e-08 5.00001L8.74227e-08 7.00001L166 7L166 5Z",
    fill: "#22B260"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 469C171.333 466.054 168.946 463.667 166 463.667C163.054 463.667 160.667 466.054 160.667 469C160.667 471.946 163.054 474.333 166 474.333C168.946 474.333 171.333 471.946 171.333 469ZM166 468H79V470H166V468Z",
    fill: "#22B260"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 348C171.333 345.054 168.946 342.667 166 342.667C163.054 342.667 160.667 345.054 160.667 348C160.667 350.946 163.054 353.333 166 353.333C168.946 353.333 171.333 350.946 171.333 348ZM166 347H79V349H166V347Z",
    fill: "#22B260"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 234C171.333 231.054 168.946 228.667 166 228.667C163.054 228.667 160.667 231.054 160.667 234C160.667 236.946 163.054 239.333 166 239.333C168.946 239.333 171.333 236.946 171.333 234ZM166 233H79V235H166V233Z",
    fill: "#22B260"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 120C171.333 117.054 168.946 114.667 166 114.667C163.054 114.667 160.667 117.054 160.667 120C160.667 122.946 163.054 125.333 166 125.333C168.946 125.333 171.333 122.946 171.333 120ZM166 119L79 119V121L166 121V119Z",
    fill: "#22B260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint1);
export default __webpack_public_path__ + "static/media/paint1.c38db381ca65f6e1a65ab6d20aed3b2d.svg";
export { ForwardRef as ReactComponent };